import {useState,useEffect} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiMenu,FiX,FiShoppingBag} = FiIcons;

function SiteHeader({bagCount,onBagOpen}) {
  const [menuOpen,setMenuOpen] = useState(false);
  const [scrolled,setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll',handler);
    return () => window.removeEventListener('scroll',handler);
  },[]);

  return (
    <>
      <div className="bg-[#15302A] text-center py-2.5 px-4">
        <p className="font-sans text-[10px] tracking-[0.3em] uppercase text-[#DDB892]">
          Complimentary shipping across India · Styled personally over WhatsApp
        </p>
      </div>
      <header className={`sticky top-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#F7F2EA]/95 backdrop-blur-md shadow-[0_2px_20px_rgba(31,27,23,0.08)]' : 'bg-transparent'}`}>
        <div className="flex items-center justify-between px-6 md:px-12 lg:px-20 h-[88px]">
          <button className="md:hidden p-2" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <SafeIcon icon={menuOpen ? FiX : FiMenu} className="text-2xl text-[#1F1B17]" />
          </button>
          <nav className="hidden md:flex items-center gap-10">
            <a href="#shop" className="font-sans text-[11px] tracking-[0.25em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] transition">Shop</a>
            <a href="#collections" className="font-sans text-[11px] tracking-[0.25em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] transition">Collections</a>
            <a href="#story" className="font-sans text-[11px] tracking-[0.25em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] transition">Atelier</a>
          </nav>
          <a href="#home" className="font-display text-3xl md:text-4xl tracking-[0.15em] text-[#1F1B17] font-medium">
            AURELLE
          </a>
          <div className="flex items-center gap-6">
            <a href="#journal" className="hidden md:block font-sans text-[11px] tracking-[0.25em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] transition">Journal</a>
            <button onClick={onBagOpen} className="flex items-center gap-2 font-sans text-[11px] tracking-[0.25em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] transition">
              <span className="hidden md:inline">Bag</span>
              <span className="relative">
                <SafeIcon icon={FiShoppingBag} className="text-xl" />
                <span className="absolute -top-1.5 -right-2 grid place-items-center w-4 h-4 rounded-full bg-[#1F3D2E] text-[9px] text-[#F7F2EA]">{bagCount}</span>
              </span>
            </button>
          </div>
        </div>
        {menuOpen && (
          <div className="md:hidden bg-[#F7F2EA] border-t border-[#DDD3BE] px-6 py-6 flex flex-col gap-5">
            <a href="#shop" onClick={() => setMenuOpen(false)} className="font-sans text-sm tracking-[0.2em] uppercase">Shop</a>
            <a href="#collections" onClick={() => setMenuOpen(false)} className="font-sans text-sm tracking-[0.2em] uppercase">Collections</a>
            <a href="#story" onClick={() => setMenuOpen(false)} className="font-sans text-sm tracking-[0.2em] uppercase">Atelier</a>
            <a href="#journal" onClick={() => setMenuOpen(false)} className="font-sans text-sm tracking-[0.2em] uppercase">Journal</a>
          </div>
        )}
      </header>
    </>
  );
}

export default SiteHeader;
